import { Position, Toaster, Intent } from "@blueprintjs/core";

const NoticeNotifiation = Toaster.create({
	position: Position.BOTTOM_RIGHT,
	intent: Intent.WARNING,
	timeout: 5000
});

export default NoticeNotifiation;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/NoticeNotification.jsx